
import { SOURCE_IOT, SOURCE_CONTROLLER, SOURCE_MANUAL } from '@/aquassist-shared/constants/types/flowMeters';
import { mapGetters } from 'vuex';

export default {

    computed: {
        ...mapGetters(['site']),
        sources() {
            return [
                {
                    name: this.$t(`devices.flowMeters.sources.${SOURCE_IOT}`),
                    value: SOURCE_IOT,
                },
                {
                    name: this.$t(`devices.flowMeters.sources.${SOURCE_CONTROLLER}`),
                    value: SOURCE_CONTROLLER,
                },
                {
                    name: this.$t(`devices.flowMeters.sources.${SOURCE_MANUAL}`),
                    value: SOURCE_MANUAL,
                },
            ];
        },
        SOURCE_IOT() {
            return SOURCE_IOT;
        },
        SOURCE_CONTROLLER() {
            return SOURCE_CONTROLLER;
        },
        SOURCE_MANUAL() {
            return SOURCE_MANUAL;
        },
    },
    methods: {
        async getAvailableMeters(availableMetersHubs, flowMeterHub) {
            if (availableMetersHubs.length < 1 && !flowMeterHub) return;
            // Find the selected hub from the availableMetersHubs array
            const selectedHub = availableMetersHubs.find(hub => hub.id === flowMeterHub);
            if (!selectedHub) {
                this.$toasted.global.toast_error({
                    message: this.$t('devices.notFound', { flowMeterHub }),
                });
            }
            // Filter the available meters based on the selected hub
            // This will filter out the meters that are already linked to a node
            this.availableMeters = [
                ...(selectedHub.directChannelsDetails || []).filter(detail => detail.node === undefined),
                ...(selectedHub.indirectChannelsDetails || []).filter(detail => detail.node === undefined),
            ];
        },
        async getAvailableProbes(availableControllersHubs, controller) {
            let availableProbes = [];
            const selectedHub = availableControllersHubs.find(hub => hub.id === controller);
            if (selectedHub) {
                availableProbes = (selectedHub.probes || []).filter(detail => detail.component === undefined);
            }

            return availableProbes;
        },
        async getAvailableFlowMetersHubs() {
            const availableFlowMetersHubs = await this.$rq.getFlowMetersHubs(this.site.id);

            return availableFlowMetersHubs.data.documents;
        },
        async getAvailableControllersHubs() {
            const availableControllersHubs = await this.$rq.getControllers(this.site.id);

            return availableControllersHubs.data.controllers;
        },
        async createFuelMeter(requestPayload, node) {
            const site = this.siteId || this.site.id;
            const payload = {
                team: this.team.id,
                site,
                node,
                ...requestPayload,
            };
            const { data } = await this.$rq.addFlowMeter(site, [payload]);
            return data[0];
        },
    },
};
